import { useQuery } from "@tanstack/react-query";
import { apiDelete, get, patch, post, put } from "./divertidogsApiUtils";

export interface RolSeguridad {
  id: string;
  codigo: string;
  categoria: string;
  descripcion: string;
}

export interface GrupoUsuario {
  id: string;
  codigo: string;
  roles: RolSeguridad[];
}

export interface NuevoGrupoUsuario {
  codigo: string;
  roles: Array<{ id: string }>;
}

export const getRoles = async (): Promise<RolSeguridad[] | undefined> => {
  return get("roles");
};

export const QUERY_LEER_ROLES = "QUERY_LEER_ROLES";

export const useGetRoles = () =>
  useQuery([QUERY_LEER_ROLES], async () => await getRoles());

export const getGruposUsuarios = async (): Promise<GrupoUsuario[] | undefined> => {
  return get("grupos-usuarios");
};

export const QUERY_LEER_GRUPOS_USUARIOS = "QUERY_LEER_GRUPOS_USUARIOS";

export const useGetGruposUsuarios = () =>
  useQuery(
    [QUERY_LEER_GRUPOS_USUARIOS],
    async () => await getGruposUsuarios()
  );

export const crearGrupoUsuario = async (
  body: NuevoGrupoUsuario
): Promise<GrupoUsuario> => {
  return post("grupos-usuarios", body);
};

export const actualizarGrupoUsuario = async ({
  id,
  body,
}: {
  id: string;
  body: NuevoGrupoUsuario;
}): Promise<void> => {
  await put(`grupos-usuarios/${id}`, body);
};

export const eliminarGrupoUsuario = async (
  id: string
): Promise<void> => {
  return apiDelete(`grupos-usuarios/${id}`);
};

export const grupoContieneUsuarios = async (
  id: string
): Promise<boolean | undefined> => {
  return get(`grupos-usuarios/${id}/contiene-usuarios`);
};

export interface UsuarioListado {
  id: string;
  email: string;
  grupoUsuario: { id: string; codigo: string } | null;
}

export const listarUsuarios = async (): Promise<UsuarioListado[] | undefined> => {
  return get("usuarios");
};

export const QUERY_LEER_USUARIOS = "QUERY_LEER_USUARIOS";

export const useListarUsuarios = () =>
  useQuery([QUERY_LEER_USUARIOS], async () => await listarUsuarios());

export const modificarUsuario = async ({
  id,
  body,
}: {
  id: string;
  body: { grupoUsuario: string | null };
}): Promise<void> => {
  await patch(`usuarios/${id}`, body);
};

export const QUERY_GRUPO_USUARIO_CONTIENE_USUARIOS =
  "QUERY_GRUPO_USUARIO_CONTIENE_USUARIOS";

export const useGrupoContieneUsuarios = (id: string) =>
  useQuery(
    [QUERY_GRUPO_USUARIO_CONTIENE_USUARIOS, id],
    async () => await grupoContieneUsuarios(id)
  );
